import IndexManager from "../index-manager";
import debuggingProps from "./index.debug";
import { handlePreview } from "./index.preview";
import { debounce } from "lodash";

(async function() {

  /* ***************** */
  /*     Settings      */
  /* ***************** */

  const manager = new IndexManager('ms', {
    // Exclusive Params
    'ms_theme': 'default',
    'ms_font': 'default',
    'ms_title': 'Milestone Bulan Ini',
    'ms_show_title': true,
    'ms_show_link': true,
    'ms_sincedate': '00:00:0000',
    'ms_show_nominal_receive': true,
    'ms_show_header_next_milestone': true,
    'ms_value_next_milestone': 'nominal',
    'ms_only_show_complete': false,
    'ms_collapse_complete_milestone': false,
    'ms_collapse_future_milestone': false,
    'ms_is_show_limit_milestone': false,
    'ms_show_total_limit_milestone': 5,
    'ms_show_icon': true,
    'ms_icon': 'https://edge-cdn.trakteer.id/images/mix/target1.png',
    'ms_list': [],
    'ms_value_type': 'nominal',

    //Colors: Default
    'ms_1_clr1': '#fafafa',
    'ms_1_clr2': '#A3001C',
    'ms_1_clr3': '#e9e9e9',
    'ms_1_clr4': '#272727',
    'ms_1_clr5': '#FFDA1F',
    'ms_1_clr6': '#fefefe',
    'ms_1_clr7': '#3CD278',
    'ms_1_clr8': '#FFDA1F',
    'ms_1_clr9': '#A3001C',

    //Colors: Retro
    'ms_2_clr1': '#ffffff',
    'ms_2_clr2': '#272727',
    'ms_2_clr3': '#272727',
    'ms_2_clr4': '#E50027',
    'ms_2_clr5': '#3CD278',
    'ms_2_clr6': '#FFDA1F',

    // Colors: Transitional
    'ms_3_clr1': '#ffffff',
    'ms_3_clr2': '#272727',
    'ms_3_clr3': '#272727',
    'ms_3_clr4': '#3CD278',
    'ms_3_clr5': '#FFDA1F',
    'ms_3_clr6': '#E9E9E9',

  });

  /* ***************** */
  /*  Widget Behavior  */
  /* ***************** */
 
  class TrWidget {

    data = {};
    setting = {};
    theme = '';

    isLoadMilestone = false;

    async setup(themeSetting, themeProps) {
      this.setting = themeSetting;
      this.theme = themeProps[this.setting['ms_theme']];
      this.theme.setup(this.setting);
      this.applyStyle();

      if (h.isTrue(this.setting['use_placeholder']) && h.isTrue(this.setting['preview']) ) {
        this.setting.ms_list = [];
      } else {
        this.setting.ms_list = await manager.loadMilestoneData();
      }
    }

    /* Styling */

    applyStyle() {
      // Set Styles
      const styles = this.theme.styles();
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        h.setThemeVar(style.var, this.setting[style.key] || style.default);
      }
      // Set Fonts
      const reqFont = this.setting['ms_font'] || 'default';
      h.setThemeVar(
        this.theme.font().var,
        reqFont === 'default' ? this.theme.font().default : "'" + reqFont + "'"
      );
    }

    async reset(data) {
      this.data = data;
    }

    async updateData(data) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }
      if(data == null) return;
      if(Object.keys(data).length === 0) return;

      await this.reset(data);
      await this.theme.render(this.data);
    }
    async updateMilestoneListAndRemaining(list, data) {
      this.setting.ms_list = await this.sortListByTarget(list);
      await this.theme.renderMilestoneList(data, this.setting.ms_list)
      await this.theme.renderRemainingMilestone(data, this.setting.ms_list)
    }

    sortListByTarget(list) {
      return list.sort(function(a, b) {
        return parseFloat(a.target) - parseFloat(b.target);
      });
    }

  }

  /* ***************** */
  /*   Widget Manager  */
  /* ***************** */

  IndexManager.prototype.updateMilestoneListAndRemainingPreview = async function(list, data) {
    this.widget.updateMilestoneListAndRemaining(list, data)
  }

  IndexManager.prototype.reloadHandler = debounce((data) => {
    manager.reload(true)
  }, 5000, { 'maxWait': 10000 });
  
  IndexManager.prototype.reload = async function (fetch = false, data = null) {
    let dataTarget = {}
    if(fetch) {
      dataTarget = await this.fetchData(/* true */)
    } else {
      dataTarget = data
    }
    await this.widget.updateData(dataTarget)
  }
  IndexManager.prototype.updateReceived = function(newTargetReceived) {
    let tempData = h.cloneProp(this.widget.data);

    const targetPrice = parseInt(tempData.targetPrice);
    const newTargetProgress = (String)(newTargetReceived / targetPrice * 100);

    this.widget.updateData(Object.assign(tempData, {
      targetProgress: newTargetProgress,
      targetReceived: newTargetReceived,
      targetValue: `${h.formatPrice(newTargetReceived)} / ${h.formatPrice(targetPrice)}`,
    }));
  }

  /*load initial data*/
  IndexManager.prototype.loadData = async function() {
    let data = await this.fetchData(/* true */)
    this.reload(false, data)
  }

  /* ***************** */
  /*      API Call     */
  /* ***************** */

  IndexManager.prototype.loadMilestoneData = async function() {
    let self = this
    return new Promise(async (resolve, reject) => {
      superagent
      .get(this.apiUrl(`stream/${this.key}/list/ms`))
      .accept('application/json')
      .end(function (err, res){
        try{
          let result = JSON.parse(res.body.settings)
          let list = (Array.isArray(result) || result != null) ? self.widget.sortListByTarget(result) : [];
          resolve(list);
        }
        catch (err){
          reject(Error(err));
        }
      });
    });
  }

  IndexManager.prototype.fetchData = async function(shouldForceRefresh = false) {
    let source = "tip-history";
    let sincedate = this.widget.setting.ms_sincedate || '00:00:0000';
    let price = 0;
    return new Promise(async (resolve, reject) => {
      superagent.get(this.apiUrl(`stream/${this.key}/target-data`))
        .query({ 
          source: source,
          sincedate: sincedate,
          price: price,
          showtarget: true,
          ...(shouldForceRefresh ? { force_refresh: true } : {})
        }) 
        .accept('application/json')
        .end(async function(err, res) {
          try {
            let data = {
              targetReceived: res.body.targetReceived,
              url: res.body.pageUrl,
              activeUnit: res.body.activeUnit,
            }
            resolve(data)
          } catch (err) {
            reject(Error(err))
          }
        });
    });
  }

  /* ***************** */
  /*     Websocket     */
  /* ***************** */

  function setupListener() {
    manager.addListenerOn('new-tip', function(data) {
      manager.reloadHandler(data)
    });
    manager.addListenerOn('new-tip-simulation', function(data) {
      manager.reloadHandler(data)
    });

    // Failover if webssockets has an issues
    if (!h.prop(manager, 'widget.setting.debug')) {
      setInterval(function() {
        manager.reload(true);
      }, 5 * 60 * 1000);
    }
  }

  /* ***************** */
  /*       Init        */
  /* ***************** */

  setupListener();

  await manager.init({
    widget: new TrWidget(),
    debug: debuggingProps,
    preview: handlePreview
  });
})();
